module.exports = __webpack_public_path__ + "static/media/2DGACM5.92abeb2a.jpg";